import { render, staticRenderFns } from "./editQuestionDetail.vue?vue&type=template&id=8079f204"
import script from "./editQuestionDetail.vue?vue&type=script&lang=js"
export * from "./editQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./editQuestionDetail.vue?vue&type=style&index=0&id=8079f204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports